import { ConnectedRouter } from "connected-react-router";
import { OidcProvider } from "redux-oidc";
import { History } from "history";
import { Provider } from "react-redux";
import React from "react";
import { Store } from "redux";
import { UserManager } from "oidc-client";
import App from "./App";

type Props = {
  store: Store;
  history: History;
  userManager: UserManager;
};

export const Root: React.FC<Props> = ({ store, history, userManager }) => (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <OidcProvider userManager={userManager} store={store}>
        <App />
      </OidcProvider>
    </ConnectedRouter>
  </Provider>
);
